import store, { modulesName } from '@/store';

export const userMixin = {
  computed: {
    userAuthenticated() {
      return store.getters[`${modulesName.userModuleName}/authenticated`];
    },
    userRole() {
      return store.getters[`${modulesName.userModuleName}/role`];
    },
    userMainCompany() {
      return store.getters[`${modulesName.userModuleName}/mainCompany`];
    },
    userProfile() {
      let profile = store.getters['$_user/fullProfile'];
      return profile;
    },
  },
  methods: {
    userHasPermissions(...permissions) {
      return store.getters[`${modulesName.userModuleName}/hasPermissions`](
        permissions
      );
    },
  },
};
